export const siteInfo = {
  name: '茄子视频',
  fullName: '茄子视频在线观看',
  tagline: '免费高清视频播放平台',
  description: '茄子视频在线观看，提供海量高清视频内容，无需下载即可流畅播放。支持多种分辨率自由切换，随时随地享受优质视频体验。',
  url: 'https://qiezi-video.example.com',
  logo: '茄子视频',
  foundedYear: '2018',
  email: 'contact@qiezi-video.example.com',
  phone: '400-888-6666',
  address: '北京市朝阳区望京科技园A座18层',
  social: {
    weibo: 'https://weibo.com/qiezivideo',
    wechat: 'qiezivideo',
    douyin: '@qiezivideo',
  },
};

export const brandStory = {
  title: '关于茄子视频',
  subtitle: '让每一个人都能轻松享受高清视频的乐趣',
  paragraphs: [
    '茄子视频成立于2018年，总部位于北京，是中国领先的免费在线视频播放平台之一。自成立以来，我们始终秉持「内容为王、用户至上」的理念，致力于为广大用户提供丰富、优质的视频内容与流畅的观看体验。',
    '我们的团队由一群热爱视频、热爱技术的年轻人组成，他们来自国内外顶尖的互联网公司与传媒机构。凭借着对视频行业的深刻理解与对技术创新的不懈追求，茄子视频在短短几年内迅速发展壮大，累计服务用户超过5000万。',
    '在内容方面，茄子视频与超过200家内容提供商建立了深度合作关系，涵盖电影、电视剧、综艺、动漫、纪录片等多个品类，确保平台内容的多样性与高质量。同时，我们也大力扶持原创内容创作，为独立创作者提供展示才华的舞台。',
    '技术上，茄子视频采用先进的分布式CDN加速与智能码率自适应技术，确保用户在任何网络环境下都能获得流畅、清晰的播放体验。我们自主研发的视频编解码方案，在保证画质的前提下，大幅降低了带宽消耗。',
    '展望未来，茄子视频将继续深耕视频领域，不断拓展内容边界，提升技术能力，为全球华语用户打造一个更加开放、多元、优质的视频内容生态。',
  ],
};

export const brandValues = [
  {
    icon: 'ri-shield-star-line',
    title: '内容为王',
    description: '精选海量优质内容，涵盖电影、电视剧、综艺、动漫、纪录片等多品类，持续更新，总有你喜欢的。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速流畅',
    description: '全球CDN加速节点覆盖，智能码率自适应技术，无论何时何地都能畅享高清流畅的视频体验。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '用户至上',
    description: '简洁清爽的界面设计，个性化推荐算法，让每一位用户都能轻松发现感兴趣的内容。',
  },
  {
    icon: 'ri-shake-hands-line',
    title: '合作共赢',
    description: '开放的内容生态，与超过200家内容提供商深度合作，为创作者提供全方位的展示与变现渠道。',
  },
];

export const milestones = [
  { year: '2018', title: '平台成立', description: '茄子视频正式上线，开启免费高清视频服务之旅。' },
  { year: '2019', title: '用户突破1000万', description: '凭借优质内容与流畅体验，注册用户数突破1000万大关。' },
  { year: '2020', title: '内容生态升级', description: '与超过100家内容提供商建立合作，内容库扩充至10万+部。' },
  { year: '2021', title: '技术革新', description: '自研智能码率自适应技术上线，大幅提升弱网环境下的播放体验。' },
  { year: '2022', title: '用户突破5000万', description: '累计服务用户突破5000万，月活跃用户超过2000万。' },
  { year: '2023', title: 'AI赋能', description: '引入AI智能推荐系统，个性化推荐准确率提升40%。' },
  { year: '2024', title: '全球化布局', description: '启动海外华人市场拓展计划，服务全球华语用户。' },
];

export const faqList = [
  {
    question: '茄子视频是否需要注册才能观看？',
    answer: '不需要。茄子视频是一个免费的视频播放平台，您无需注册即可直接观看平台上的所有视频内容。注册账号后，您可以享受个性化推荐、收藏视频、评论互动等更多功能。',
  },
  {
    question: '茄子视频的视频画质如何？支持哪些分辨率？',
    answer: '茄子视频提供从360P到1080P全高清的多种分辨率选择，部分热门内容更支持4K超高清播放。平台采用智能码率自适应技术，会根据您的网络状况自动选择最佳分辨率，确保流畅观看。',
  },
  {
    question: '使用茄子视频需要安装什么软件吗？',
    answer: '茄子视频支持网页版直接访问，无需下载安装任何软件。只需打开浏览器，访问茄子视频官网即可开始观看。同时，我们也提供了Android和iOS移动端APP，您可以在各大应用商店搜索「茄子视频」下载。',
  },
  {
    question: '茄子视频是否支持离线下载？',
    answer: '网页版茄子视频不支持离线下载功能，需要联网在线观看。如果您需要离线观看，可以下载茄子视频移动端APP，APP内支持将视频缓存到本地，方便在无网络环境下观看。',
  },
  {
    question: '为什么有些视频播放不流畅或无法播放？',
    answer: '视频播放不流畅通常与您的网络状况有关。建议您尝试以下操作：1) 切换到较低分辨率；2) 检查网络连接是否稳定；3) 清除浏览器缓存；4) 尝试更换浏览器。如果问题持续存在，请联系客服获取帮助。',
  },
  {
    question: '茄子视频的广告政策是什么？',
    answer: '茄子视频作为免费视频平台，会在视频播放前或播放过程中展示少量广告以维持平台运营。我们承诺广告时长控制在合理范围内，不会过度影响您的观看体验。未来也将推出会员去广告服务。',
  },
  {
    question: '如何在茄子视频上发布自己的视频内容？',
    answer: '欢迎创作者加入茄子视频！您可以通过「创作者中心」提交入驻申请，审核通过后即可上传您的原创视频内容。我们为优质创作者提供流量扶持、收益分成等多种激励政策。具体可访问创作者中心页面了解详情。',
  },
  {
    question: '茄子视频的隐私政策是怎样的？',
    answer: '茄子视频高度重视用户隐私保护。我们严格遵守相关法律法规，不会在未经用户同意的情况下收集、使用或分享用户的个人信息。详细的隐私政策请查看我们网站的「隐私政策」页面。',
  },
];